export const memberBlockedSchemas: string[] = [
  'ListSubscription',
  'GetLowBalanceAlert',
  'CheckConfigurationAndRewardOfChannel',
  'liveConferences',
  'CustomerBillingAddress',
  'InvoicesV2',
  'GetAutoRechargeConfigs',
  'availablePhoneNumbers',
];

export const suspendedAccountEnabledRoutes: string[] = [
  'authMe',
  'workspaceAuthMeV2',
  'ListPaymentSource',
  'EstimateRenewFailedSubscriptionV2',
  'ActiveWorkspacesV2',
];

// Money-moving mutations that must carry an idempotency key. See idempotency-link.ts
// and docs/superpowers/specs/2026-07-17-purchase-idempotency-key-design.md.
export const idempotentOperations: string[] = [
  'PurchasePackage',
  // 'SubscribeNumberPlan',
  // 'SubscribeWorkspacePlanAndInviteUser',
];
